import { createSelector } from 'reselect';
import { DataState } from '../state';

export const getBalancesForWithdrawal = createSelector(
  (state: DataState) => state.accountData.balances.balancesForWithdrawal,
  balances => balances
);

export const getIsFetchingBalancesForWithdrawal = createSelector(
  (state: DataState) => state.accountData.balances.isFetchingForWithdrawal,
  isFetching => isFetching
);
